let holidayDataInGermany = [
    {
        "2023-01-01": "Neujahr",
        "2023-04-07": "Karfreitag",
        "2023-04-10": "Ostermontag",
        "2023-05-01": "Tag der Arbeit",
        "2023-05-18": "Christi Himmelfahrt",
        "2023-05-29": "Pfingstmontag",
        "2023-10-03": "Tag der Deutschen Einheit",
        "2023-12-25": "1. Weihnachtstag",
        "2023-12-26": "2. Weihnachtstag"
    },
    {
        "2024-01-01": "Neujahr",
        "2024-03-29": "Karfreitag",
        "2024-04-01": "Ostermontag",
        "2024-05-01": "Tag der Arbeit",
        "2024-05-09": "Christi Himmelfahrt",
        "2024-05-20": "Pfingstmontag",
        "2024-10-03": "Tag der Deutschen Einheit",
        "2024-12-25": "1. Weihnachtstag",
        "2024-12-26": "2. Weihnachtstag"
    },
    {
        "2025-01-01": "Neujahr",
        "2025-04-18": "Karfreitag",
        "2025-04-21": "Ostermontag",
        "2025-05-01": "Tag der Arbeit",
        "2025-05-29": "Christi Himmelfahrt",
        "2025-06-09": "Pfingstmontag",
        "2025-10-03": "Tag der Deutschen Einheit",
        "2025-12-25": "1. Weihnachtstag",
        "2025-12-26": "2. Weihnachtstag"
    },
    {
        "2026-01-01": "Neujahr",
        "2026-04-03": "Karfreitag",
        "2026-04-06": "Ostermontag",
        "2026-05-01": "Tag der Arbeit",
        "2026-05-14": "Christi Himmelfahrt",
        "2026-05-25": "Pfingstmontag",
        "2026-10-03": "Tag der Deutschen Einheit",
        "2026-12-25": "1. Weihnachtstag",
        "2026-12-26": "2. Weihnachtstag"
    },
    {
        "2027-01-01": "Neujahr",
        "2027-03-26": "Karfreitag",
        "2027-03-29": "Ostermontag",
        "2027-05-01": "Tag der Arbeit",
        "2027-05-06": "Christi Himmelfahrt",
        "2027-05-17": "Pfingstmontag",
        "2027-10-03": "Tag der Deutschen Einheit",
        "2027-12-25": "1. Weihnachtstag",
        "2027-12-26": "2. Weihnachtstag"
    },
    {
        "2028-01-01": "Neujahr",
        "2028-04-14": "Karfreitag",
        "2028-04-17": "Ostermontag",
        "2028-05-01": "Tag der Arbeit",
        "2028-05-25": "Christi Himmelfahrt",
        "2028-06-05": "Pfingstmontag",
        "2028-10-03": "Tag der Deutschen Einheit",
        "2028-12-25": "1. Weihnachtstag",
        "2028-12-26": "2. Weihnachtstag"
    },
    {
        "2029-01-01": "Neujahr",
        "2029-03-30": "Karfreitag",
        "2029-04-02": "Ostermontag",
        "2029-05-01": "Tag der Arbeit",
        "2029-05-10": "Christi Himmelfahrt",
        "2029-05-21": "Pfingstmontag",
        "2029-10-03": "Tag der Deutschen Einheit",
        "2029-12-25": "1. Weihnachtstag",
        "2029-12-26": "2. Weihnachtstag"
    },
    {
        "2030-01-01": "Neujahr",
        "2030-04-19": "Karfreitag",
        "2030-04-22": "Ostermontag",
        "2030-05-01": "Tag der Arbeit",
        "2030-05-30": "Christi Himmelfahrt",
        "2030-06-10": "Pfingstmontag",
        "2030-10-03": "Tag der Deutschen Einheit",
        "2030-12-25": "1. Weihnachtstag",
        "2030-12-26": "2. Weihnachtstag"
    },
    {
        "2031-01-01": "Neujahr",
        "2031-04-11": "Karfreitag",
        "2031-04-14": "Ostermontag",
        "2031-05-01": "Tag der Arbeit",
        "2031-05-22": "Christi Himmelfahrt",
        "2031-06-02": "Pfingstmontag",
        "2031-10-03": "Tag der Deutschen Einheit",
        "2031-12-25": "1. Weihnachtstag",
        "2031-12-26": "2. Weihnachtstag"
    },
    {
        "2032-01-01": "Neujahr",
        "2032-03-26": "Karfreitag",
        "2032-03-29": "Ostermontag",
        "2032-05-01": "Tag der Arbeit",
        "2032-05-06": "Christi Himmelfahrt",
        "2032-05-17": "Pfingstmontag",
        "2032-10-03": "Tag der Deutschen Einheit",
        "2032-12-25": "1. Weihnachtstag",
        "2032-12-26": "2. Weihnachtstag"
    },
    {
        "2033-01-01": "Neujahr",
        "2033-04-15": "Karfreitag",
        "2033-04-18": "Ostermontag",
        "2033-05-01": "Tag der Arbeit",
        "2033-05-26": "Christi Himmelfahrt",
        "2033-06-06": "Pfingstmontag",
        "2033-10-03": "Tag der Deutschen Einheit",
        "2033-12-25": "1. Weihnachtstag",
        "2033-12-26": "2. Weihnachtstag"
    },
    {
        "2034-01-01": "Neujahr",
        "2034-04-07": "Karfreitag",
        "2034-04-10": "Ostermontag",
        "2034-05-01": "Tag der Arbeit",
        "2034-05-18": "Christi Himmelfahrt",
        "2034-05-29": "Pfingstmontag",
        "2034-10-03": "Tag der Deutschen Einheit",
        "2034-12-25": "1. Weihnachtstag",
        "2034-12-26": "2. Weihnachtstag"
    },
    {
        "2035-01-01": "Neujahr",
        "2035-04-23": "Karfreitag",
        "2035-04-26": "Ostermontag",
        "2035-05-01": "Tag der Arbeit",
        "2035-06-03": "Christi Himmelfahrt",
        "2035-06-14": "Pfingstmontag",
        "2035-10-03": "Tag der Deutschen Einheit",
        "2035-12-25": "1. Weihnachtstag",
        "2035-12-26": "2. Weihnachtstag"
    },
    {
        "2036-01-01": "Neujahr",
        "2036-04-11": "Karfreitag",
        "2036-04-14": "Ostermontag",
        "2036-05-01": "Tag der Arbeit",
        "2036-05-22": "Christi Himmelfahrt",
        "2036-06-02": "Pfingstmontag",
        "2036-10-03": "Tag der Deutschen Einheit",
        "2036-12-25": "1. Weihnachtstag",
        "2036-12-26": "2. Weihnachtstag"
    },
    {
        "2037-01-01": "Neujahr",
        "2037-04-03": "Karfreitag",
        "2037-04-06": "Ostermontag",
        "2037-05-01": "Tag der Arbeit",
        "2037-05-14": "Christi Himmelfahrt",
        "2037-05-25": "Pfingstmontag",
        "2037-10-03": "Tag der Deutschen Einheit",
        "2037-12-25": "1. Weihnachtstag",
        "2037-12-26": "2. Weihnachtstag"
    },
    {
        "2038-01-01": "Neujahr",
        "2038-04-23": "Karfreitag",
        "2038-04-26": "Ostermontag",
        "2038-05-01": "Tag der Arbeit",
        "2038-06-03": "Christi Himmelfahrt",
        "2038-06-14": "Pfingstmontag",
        "2038-10-03": "Tag der Deutschen Einheit",
        "2038-12-25": "1. Weihnachtstag",
        "2038-12-26": "2. Weihnachtstag"
    }
];


let publicHolidays = holidayDataInGermany.flatMap(holidays => Object.keys(holidays));

function isWeekendOrHoliday(date) {
    const dayOfWeek = date.getDay();
    const dateString = date.toISOString().split('T')[0];
    return dayOfWeek === 0 || dayOfWeek === 6 || publicHolidays.includes(dateString);
}

function formatDateToGerman(date) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('de-DE', options);
}

function calculateDeliveryDate(inputString) {
    const timestampRegex = /^\d{10}$/;
    if (inputString.startsWith('Nicht')) return inputString;
    if (timestampRegex.test(inputString)) {
        const timestampMilliseconds = parseInt(inputString, 10) * 1000;
        const date = new Date(timestampMilliseconds);

        // Get the current date
        const currentDate = new Date();

        // Calculate the difference in months
        const monthDifference = (date.getFullYear() * 12 + date.getMonth()) - (currentDate.getFullYear() * 12 + currentDate.getMonth());

        let formattedDate;
        if (monthDifference <= 1) {
            // If the difference is less than or equal to one month, format the full date
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            formattedDate = date.toLocaleDateString('de-DE', options);
        } else {
            // If the difference is more than one month, format only the month and the year
            const options = { year: 'numeric', month: 'long' };
            formattedDate = date.toLocaleDateString('de-DE', options);
        }

        return `Verfügbar ab ${formattedDate}, Lieferung 1-2 Werktage später.`;
    }

    const regex = /\d+/g;
    const matches = inputString.match(regex);

    if (!matches) return inputString;

    let currentDate = new Date();


    if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
        while (isWeekendOrHoliday(currentDate)) {
            currentDate.setDate(currentDate.getDate() + 1);
        }
    }

    const minDays = parseInt(matches[0]);
    const maxDays = matches.length > 1 ? parseInt(matches[1]) : minDays;

    let minDeliveryDate = new Date(currentDate);
    let maxDeliveryDate = new Date(currentDate);

    let addedMinDays = 0;
    let addedMaxDays = 0;

    while (addedMinDays < minDays || addedMaxDays < maxDays) {
        currentDate.setDate(currentDate.getDate() + 1);

        if (isWeekendOrHoliday(currentDate)) continue;

        if (addedMinDays < minDays) {
            minDeliveryDate = new Date(currentDate);
            addedMinDays++;
        }

        if (addedMaxDays < maxDays) {
            maxDeliveryDate = new Date(currentDate);
            addedMaxDays++;
        }
    }

    return `Lieferung zwischen ${formatDateToGerman(minDeliveryDate)} und  ${formatDateToGerman(maxDeliveryDate)}`;
  
}